import Toast from "components/toast";
import {
  _goToBack,
  _goToRoot,
  //  _goToBack
} from "routers/helper";

export const onAddCustomerRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToRoot();
};

export const onEditCustomerRes = (res: { data: any }) => {
  Toast.success({ message: res?.data?.message });
};

export const onDeleteCustomerRes = onEditCustomerRes;
